import React, { Fragment, useContext, useState } from "react";
import { Alert, Button, Col, Container, Form, InputGroup, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";
import PassCard from "../passes/PassCard";
import "./PaymentForPass.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import PaymentTypesButtons from "../buttons/PaymentTypesButtons";
import SummaryViewAfterPayment from "../SummaryViewAfterPayment";

const PaymentForPassModal = (props) => {
    const { t } = useTranslation();
    const { onClose, pass, onProceed, signUpForClass, userID } = props;
    const { checkServerData, setAlerts } = useContext(BasicContext);
    const [blockForm, setBlockForm] = useState(false);
    const [formChanged, setFormChanged] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState(null);
    const initData = { discount_code_name: "", discount_value: null, discount_rate: null };
    const [discountCode, setDiscountCode] = useState(initData);
    const [loading, setLoading] = useState(false);
    const [summaryView, setSummaryView] = useState(null);
    const [blockCheckBtn, setBlockCheckBtn] = useState(false);

    const checkValidation = (e) => {
        e.preventDefault();
        const errors = [];
        //console.log("check validation = payment for pass modal");
        if (!paymentMethod) {
            $(`#paymentType`).addClass("is-invalid");
            errors.push(t("error.noCheckedPaymentMethod"));
        }

        if (errors.length > 0) {
            const list = [];
            errors.forEach((e) => {
                list.push({ variant: "danger", message: e });
            });
            setAlerts(list);
        } else {
            //console.log("registeringPurchase");
            setAlerts([{ variant: "info", message: t("info.registeringPurchase") }]);
            setBlockForm(true);
            registerPurchase();
        }
    };

    const registerPurchase = async () => {
        const res = await postMethod("/register-pass-purchase", { pass: pass, paymentMethod: paymentMethod, discountCode: discountCode, userID: userID });
        if (checkServerData(res)) {
            if (res.data.code === "passPaidForStudent") {
                //console.log("passPaidForStudent");
                setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "passPaidForStudent" }]);
                onProceed();
            } else {
                setLoading(true);
                setSummaryView(res.data);
                setAlerts([]);
                setTimeout(() => {
                    setLoading(false);
                }, 500);
            }
        } else setBlockForm(false);
    };

    const checkDiscountCode = async () => {
        const res = await postMethod("/check-discount-code", { discountCodeName: discountCode.discount_code_name });
        if (checkServerData(res)) {
            setDiscountCode({ ...discountCode, discount_value: res.data.code.discount_value, discount_rate: res.data.code.discount_rate });
            setAlerts([]);
        } else setDiscountCode(initData);
        setBlockForm(false);
        setBlockCheckBtn(false);
    };

    return (
        <Fragment>
            <Modal show={true} onHide={onClose} backdrop={formChanged ? "static" : true}>
                <Modal.Header closeButton>
                    <Modal.Title>{t("payments.paymentForPass")}</Modal.Title>
                </Modal.Header>
                {loading ? (
                    <Container>
                        <Row>
                            <Col className="my-5 text-center">
                                <p className="h4">
                                    {t("loadingData")} <FontAwesomeIcon icon={faSpinner} className="ms-2 rotate-center" />
                                </p>
                            </Col>
                        </Row>
                    </Container>
                ) : summaryView ? (
                    <SummaryViewAfterPayment
                        pass={pass}
                        summaryView={summaryView}
                        paymentMethod={paymentMethod}
                        discountCode={discountCode}
                        signUpForClass={signUpForClass}
                        onClose={onClose}
                        onProceed={onProceed}
                    />
                ) : (
                    <Form onSubmit={checkValidation} autoComplete="off">
                        <Modal.Body>
                            <Row>
                                <Col xs={12}>
                                    <input type="text" name="prevent-autofill" id="prevent-autofill" style={{ display: "none" }} autoComplete="off" />
                                    <Row>
                                        <Col xs={12}>
                                            <Form.Label className="w-100">{t(`passes.pass`)}</Form.Label>
                                            <PassCard i={0} pass={pass} smallCard discountCode={discountCode} />
                                        </Col>
                                        <Col xs={12}>
                                            <Form.Group className="my-3" controlId={`discountCode`}>
                                                <Form.Label className="w-100">{t(`codes.discountCode`)}</Form.Label>
                                                <p className="text-small">{t("codes.typeCodeHelper")}</p>
                                                <InputGroup className={discountCode.discount_rate || discountCode.discount_value ? "mb-1" : "mb-3"}>
                                                    <Form.Control
                                                        placeholder={t("codes.typeCode")}
                                                        aria-label="discountCode"
                                                        aria-describedby="basic-addon2"
                                                        value={discountCode.discount_code_name}
                                                        disabled={blockForm}
                                                        onChange={(e) => {
                                                            setDiscountCode({ ...discountCode, discount_code_name: e.target.value });
                                                            $(`#discountCode`).removeClass("is-invalid");
                                                        }}
                                                    />
                                                    <Button
                                                        disabled={blockCheckBtn}
                                                        variant="outline-primary"
                                                        id="button-addon2"
                                                        onClick={() => {
                                                            setFormChanged(true);
                                                            setBlockCheckBtn(true);
                                                            setBlockForm(true);
                                                            setAlerts([{ variant: "info", message: t("info.checkingDiscountCode") }]);
                                                            checkDiscountCode();
                                                        }}
                                                    >
                                                        {t("apply")}
                                                    </Button>
                                                </InputGroup>
                                                {(discountCode.discount_rate || discountCode.discount_value) && (
                                                    <Alert variant="info" className="alert-small mb-3">
                                                        <FontAwesomeIcon icon={faCircleInfo} className="me-1 me-lg-2" />
                                                        {t("info.assignedDiscount", {
                                                            discount: discountCode.discount_rate ? `${discountCode.discount_rate} %` : `${discountCode.discount_value} ${t("currency")}`,
                                                        })}
                                                    </Alert>
                                                )}
                                            </Form.Group>
                                            <PaymentTypesButtons blockForm={blockForm} paymentMethod={paymentMethod} setPaymentMethod={setPaymentMethod} setFormChanged={setFormChanged} showAlerts />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-secondary" onClick={onClose}>
                                {t("cancel")}
                            </Button>
                            <Button variant="primary" type="submit" disabled={!formChanged || blockForm}>
                                {t("passes.buyPass")}
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Modal>
        </Fragment>
    );
};

export default PaymentForPassModal;
